import { render, staticRenderFns } from "./cousult-mx.vue?vue&type=template&id=07645e9c&scoped=true&"
import script from "./cousult-mx.vue?vue&type=script&lang=js&"
export * from "./cousult-mx.vue?vue&type=script&lang=js&"
import style0 from "./cousult-mx.vue?vue&type=style&index=0&id=07645e9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07645e9c",
  null
  
)

export default component.exports